import styled from 'styled-components';

export const Container = styled.div`
  margin-bottom: 25px;

  .title {
    font-weight: bold;
    margin-bottom: 15px;
    line-height: 1;
    text-transform: uppercase;
    font-size: 0.75rem;
  }

  .items {
    .item {
      list-style: none;
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-bottom: 15px;

      &:last-child {
        margin-bottom: 0px;
      }

      &__link {
        display: flex;
        color: #0060b6;
        text-decoration: none;
      }

      &__link:hover {
        color: #00a0c6;
        text-decoration: none;
        cursor: pointer;
      }

      &__title {
        font-weight: 400;
        display: block;
        color: #212529;
      }

      &__description {
        display: block;
        font-size: 0.727rem;
        color: #212529;
      }

      &__icon {
        width: 50px;
        height: 50px;
        margin-right: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        background-color: #dfe1e5;
        font-size: 25px;
        box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.25);
        color: #185335;
      }

      &:hover {
        .item__icon {
          background-color: #c1c7d0;
        }

        .item__title {
          color: #185335;
        }

        .item__description {
          color: #212529;
        }
      }
    }
  }
`;
